import { AddCircle } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { SuggestedTopicChipWrapper } from "./TopicsSection.styled";

interface ISuggestedTopicChipProps {
    label: string;
    onClick: () => void;
    disabled?: boolean;
    "data-automation"?: string;
}

export const SuggestedTopicChip = ({
    label,
    onClick,
    disabled = false,
    "data-automation": dataAutomation,
}: ISuggestedTopicChipProps) => (
    <SuggestedTopicChipWrapper
        type="button"
        onClick={disabled ? undefined : onClick}
        $disabled={disabled}
        disabled={disabled}
        data-automation={dataAutomation}
    >
        <Text
            fontVariant="chip1"
            color={colorsPalettes.carbon[disabled ? 250 : 400]}
        >
            {label}
        </Text>
        <AddCircle
            size="sm"
            color={colorsPalettes.carbon[disabled ? 200 : 300]}
        />
    </SuggestedTopicChipWrapper>
);
